// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3pPW3","name":"styles_name__1QmqW","actions":"styles_actions__2MOG3","iconButton":"styles_iconButton__3zBqG"};